function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.23 10.64a1 1 0 001.41.13L11 7.14V19a1 1 0 002 0V7.14l4.36 3.63a1 1 0 101.28-1.54l-6-5-.15-.09-.13-.07a1 1 0 00-.72 0l-.13.07-.15.09-6 5a1 1 0 00-.13 1.41z",
  "data-name": "arrow-upward"
}));

function SvgIconArrowUpwardOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBkYXRhLW5hbWU9ImFycm93LXVwd2FyZCI+PHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB0cmFuc2Zvcm09InJvdGF0ZSgxODAgMTIgMTIpIiBvcGFjaXR5PSIwIi8+PHBhdGggZD0iTTUuMjMgMTAuNjRhMSAxIDAgMCAwIDEuNDEuMTNMMTEgNy4xNFYxOWExIDEgMCAwIDAgMiAwVjcuMTRsNC4zNiAzLjYzYTEgMSAwIDEgMCAxLjI4LTEuNTRsLTYtNS0uMTUtLjA5LS4xMy0uMDdhMSAxIDAgMCAwLS43MiAwbC0uMTMuMDctLjE1LjA5LTYgNWExIDEgMCAwIDAtLjEzIDEuNDF6Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgIconArrowUpwardOutline as ReactComponent };